var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hl-info",on:{"click":function($event){return _vm.detail('geneVariation')}}},[_c('label',{attrs:{"for":""}},[_vm._v(" 肿瘤发生发展相关基因变异（临床意义不明）III类")]),_c('i',{staticClass:"iconfont icon-right_medium"})])
}
var staticRenderFns = []

export { render, staticRenderFns }